import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

import { ALERTS } from 'app/@common/constants'

// Display-only translation. `value` ('5'/'6'/...) stays the identity; ALERTS.RATES /
// ALERTS.AVAILABILITY constants are match keys elsewhere (useAlerts.js) — never translate them.
const RATES_LABEL = () => i18n.t('alerts:type.rates', { defaultValue: ALERTS.RATES })
const AVAILABILITY_LABEL = () => i18n.t('alerts:type.availability', { defaultValue: ALERTS.AVAILABILITY })


export default function SelectAlertType({ ...props }) {

    const getDataTabSelected = (alertType, available=null) => {
        const data = {
            [ALERTS.TYPE.COMPETITION]: () => {
                return [
                    ...available?.includes(5) ? [{ label: RATES_LABEL(), value: '5' }] : [],
                    ...available?.includes(6) ? [{ label: AVAILABILITY_LABEL(), value: '6' }] : [],
                ]
            },
            [ALERTS.TYPE.PARITY_OTA]: () => {
                return [
                    ...available?.includes(2) ? [{ label: RATES_LABEL(), value: '2' }] : [],
                    ...available?.includes(4) ? [{ label: AVAILABILITY_LABEL(), value: '4' }] : [],
                ]
            },
            [ALERTS.TYPE.PARITY_META]: () => {
                return [
                    ...available?.includes(1) ? [{ label: RATES_LABEL(), value: '1' }] : [],
                    ...available?.includes(3) ? [{ label: AVAILABILITY_LABEL(), value: '3' }] : [],
                ]
            },
            [ALERTS.TYPE.PACKAGES]: () => {
                return [
                    ...available?.includes(7) ? [{ label: RATES_LABEL(), value: '7' }] : [],
                    ...available?.includes(8) ? [{ label: AVAILABILITY_LABEL(), value: '8' }] : [],
                ]
            },
            [ALERTS.TYPE.RATE_CONDITIONS]: () => {
                return [
                    { label: i18n.t('alerts:type.rateConditions', { defaultValue: ALERTS.RATE_CONDITIONS }), value: '9' }
                ]
            }
        }
        
        return data[alertType]()
    }

    const myProps = {
        placeholder: i18n.t('common:filters.allAlertTypes'),
        firstSelect: false, isClearable: false, options: getDataTabSelected(props.tabAlertType || ALERTS.TYPE.COMPETITION, props.available),
        icon: { icon: 'keyboard' }, isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}